<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-model-item label="广告所属" prop="typeId">
                <a-select
                  show-search
                  v-model="queryParam.typeId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in listType" :key="d.id">{{ d.remark }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="标题">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.title" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="queryParam.auditingState"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :value="0">审核中</a-select-option>
                  <a-select-option :value="1">审核通过</a-select-option>
                  <a-select-option :value="2">审核未通过</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="上架状态">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="queryParam.upState"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :value="0">下架</a-select-option>
                  <a-select-option :value="1">上架</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['banner:banner:add']">
          <a-icon type="plus" />新增
        </a-button>
        <!-- <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['banner:banner:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['banner:banner:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['abm-fix:dev:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
      <CreateStatus ref="createStatus"  @ok="getList"></CreateStatus>
      <Detail ref="Detail"></Detail>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="upState" slot-scope="text, record" >
          <!-- {{ parseTime(record.createTime) }} -->
          <a-tag color="red" v-if="record.upState == 0"> 下架 </a-tag>
          <a-tag color="green" v-else> 上架 </a-tag>
        </span>
        <div slot="fileUrl" slot-scope="text, record">
          <!-- <div v-viewer>
            <img :src="$url + record.pic" alt="" v-if="form.pic" />
          </div> -->
          <!-- 121212 -->
          <!-- {{ parseTime(record.createTime) }} -->
          <!-- {{ record.pic }} -->
          <div v-viewer>
            <img
              :src="$url + record.fileUrl"
              alt=""
              style="width: 50px; height: 50px"
              @error="
                (e) => {
                  e.target.src = errorImage
                }
              "
            />
          </div>
        </div>
        <span slot="auditingState" slot-scope="text, record">
          <!-- {{ parseTime(record.createTime) }} -->
          <a-tag color="red" v-if="record.auditingState == 2"> 审核未通过 </a-tag>
          <a-tag color="green" v-else-if="record.auditingState == 1"> 通过 </a-tag>
          <a-tag color="orange" v-else> 审核中 </a-tag>
        </span>
        <span slot="endTime" slot-scope="text, record"> {{ record.startTime }}-{{ record.endTime }} </span>
        <span slot="openType" slot-scope="text, record">
          <!-- {{ parseTime(record.createTime) }} -->
          <!-- <a-tag color="red" v-if="record.status"> 禁用 </a-tag>
          <a-tag color="green" v-else> 启用 </a-tag> -->
          {{ record.openType == 0 ? '无动作' : record.openType == 1 ? '跳内文本' : '跳外部地' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['banner:banner:edit']" v-if="record.upState==0"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['abm-fix:model:remove']" v-if="record.upState==0" />
          <a-dropdown v-hasPermi="['system:job:edit', 'system:tenant:query']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['banner:banner:remove']" v-if="record.upState==0">
                <a @click="handleDelete(record)" v-hasPermi="['banner:banner:remove']"> 删除 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['banner:banner:edit2']" v-if="record.auditingState == 0">
                <a @click="$refs.createStatus.handleUpdate(record, undefined)" v-hasPermi="['banner:banner:edit2']">
                  审核
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['banner:banner:edit3']" v-if="record.auditingState == 1">
                <a @click="handleDeletes(record)" v-hasPermi="['banner:banner:edit3']">
                  {{ record.upState ? '下架' : '上架' }}
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['banner:banner:query']">
                <a @click="$refs.Detail.handleUpdate(record, undefined)" v-hasPermi="['banner:banner:query']"> 详情 </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, upState } from '@/api/pressure/carousel'
import CreateForm from './modules/CreateForm'
import CreateStatus from './modules/CreateStatus'
import Detail from './modules/detail'

import { tableMixin } from '@/store/table-mixin'
import { typeList } from '@/api/pressure/advertisement'

export default {
  name: 'Post',
  components: {
    CreateForm,
    CreateStatus,
    Detail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      errorImage: require('/src/assets/images/defaultImg.png'),
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      listType: [],
      columns: [
        {
          title: '标题',
          dataIndex: 'title',
          align: 'center',
        },
        {
          title: '广告所属',
          dataIndex: 'typeName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '图片',
          dataIndex: 'fileUrl',
          scopedSlots: { customRender: 'fileUrl' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '简介说明',
          dataIndex: 'overviewVal',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '跳转类型',
          dataIndex: 'openType',
          scopedSlots: { customRender: 'openType' },
          align: 'center',
        },
        {
          title: '审核状态',
          dataIndex: 'auditingState',
          scopedSlots: { customRender: 'auditingState' },
          align: 'center',
        },
        {
          title: '上架状态',
          dataIndex: 'upState',
          scopedSlots: { customRender: 'upState' },
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          width: '160px',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '130px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getType()
  },
  computed: {},
  watch: {},
  methods: {
    getType() {
      typeList().then((res) => {
        console.log(res, '的点点滴滴')
        this.listType = res.data.records
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      console.log(row.auditingState ,'row.auditingState ')
      
      const text = row.upState === 0 ? '是否上架此数据?' : '是否下架此数据?'
      this.$confirm({
        title: text,
        onOk() {
          return upState({ id: row.id, status: row.upState ? 0 : 1 }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
